{
  "versionMetadata": {
    "version": "0.17.3",
    "commitHash": "f325edefc2b6f74b049811c8c9d4c36306cd7efd\n",
    "libVersion": "1.21.4-1-1",
    "libSourceVersion": "1.21.4",
    "libStateVersion": "1",
    "libNetworkVersion": "1"
  }
}